import SplineChart from './SplineChart';
export default SplineChart;